import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { withBible } from "../../../Bible/BibleContainer";
import { withChapter } from "../../ChapterContainer";
import { isPhoneDevice } from "../../../../utils/mobile";

const Reference = styled.span`
  color: ${props => props.theme.appBarText};
  user-select: none;
`;

export const BookChapterReference = ({ bible, chapter }) => {
  const maxLength = 7;
  const chapterReference = chapter.getChapterReference({
    bibleId: bible.currentBibleId,
    chapterId: chapter.currentChapterId,
    limit: isPhoneDevice() ? maxLength : undefined
  });

  return <Reference>{chapterReference}</Reference>;
};

BookChapterReference.propTypes = {
  bible: PropTypes.shape({
    currentBibleId: PropTypes.string.isRequired
  }).isRequired,
  chapter: PropTypes.shape({
    currentChapterId: PropTypes.string,
    getChapterReference: PropTypes.func.isRequired
  }).isRequired
};

export default withChapter(withBible(BookChapterReference));
